import {NgModule} from '@angular/core';
import {AuthGuardService} from '../auth-guard.service';
import {RouterModule} from '@angular/router';

const routes = [
    {
        path: 'dashboard',
        canActivate: [AuthGuardService],
        loadChildren: () =>
            import('../dashboard-module/dashboard.module').then(
                (m) => m.DashboardModule
            )
    },
    {
        path: 'beneficiaries',
        canActivate: [AuthGuardService],
        loadChildren: () =>
            import('../dashboard-module/beneficiaries/beneficiaries.module').then(
                (m) => m.BeneficiariesModule
            )
    },
    {
        path: 'scan-and-go',
        canActivate: [AuthGuardService],
        loadChildren: () =>
            import('../scan-and-go/scan-and-go.module').then(
                (m) => m.ScanAndGoModule
            )
    },
    {
        path: 'in-store-shopping',
        canActivate: [AuthGuardService],
        loadChildren: () =>
            import('../shopping-in-store/shopping-in-store.module').then(
                (m) => m.ShoppingInStoreModule
            )
    },
    {
        path: 'home',
        canActivate: [AuthGuardService],
        loadChildren: () =>
            import('../app-mode-selector/app-mode-selector.module').then(
                (m) => m.AppModeSelectorModule
            )
    },
    {
        path: 'tickets',
        canActivate: [AuthGuardService],
        loadChildren: () => import('../tickets/tickets.module').then(module => module.TicketsModule)
    },
    {
        path: 'profile',
        canActivate: [AuthGuardService],
        loadChildren: () =>
            import('../profile/profile.module').then(
                m => m.ProfileModule
            )
    },
    {
        path: 'policies',
        loadChildren: () =>
            import('../policies/policies.module').then(
                m => m.PoliciesModule
            )
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LayoutRoutingModule {}
